module.exports = __webpack_public_path__ + "img/hr-V-L-1-unload-standup-shadow.8cb46167.png";